import React, { useEffect, useState, useContext, createContext } from 'react';

export type User = any; // Replace with your user type if desired

interface AuthContextType {
  user: User | null;
  jwt: string | null;
  login: (user: User, jwt: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export type AuthProviderProps = {
  children: React.ReactNode;
};

export function AuthProvider({ children }: AuthProviderProps) {
  const [user, setUser] = useState<User | null>(null);
  const [jwt, setJwt] = useState<string | null>(null);

  // On mount, check for user in localStorage
  useEffect(() => {
    const stored = localStorage.getItem('qrhub_user');
    if (stored) {
      const { user, jwt } = JSON.parse(stored);
      setUser(user);
      setJwt(jwt);
    }
  }, []);

  // Save user to localStorage
  useEffect(() => {
    if (user && jwt) {
      localStorage.setItem('qrhub_user', JSON.stringify({ user, jwt }));
    } else {
      localStorage.removeItem('qrhub_user');
    }
  }, [user, jwt]);

  const login = (user: User, jwt: string) => {
    setUser(user);
    setJwt(jwt);
  };

  const logout = () => {
    setUser(null);
    setJwt(null);
  };

  return (
    <AuthContext.Provider value={{ user, jwt, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
